module.exports = __webpack_public_path__ + "static/jerry-rice-ac7cab3b23e168c77423b85dbee07d43.jpeg";